import { Component } from '@angular/core';
import { CustomCellEditorParams } from '@app/shared/components/cell-edit/abstract.cell-editor';
import { TextCellEditComponent } from '@app/shared/components/cell-edit/text-cell-edit/text-cell-edit.component';
import path from 'path-browserify';


@Component({
  selector: 'file-name-cell-edit',
  templateUrl: '../text-cell-edit/text-cell-edit.component.html',
  styleUrls: ['../text-cell-edit/text-cell-edit.component.scss'],
  standalone: false
})
export class FileNameCellEditComponent extends TextCellEditComponent {
  private extension: string;

  /**
   * Initialization method for the render component
   * @param params A merge of default cell editor params and custom params
   */
  public agInit(params: CustomCellEditorParams<string>): void {
    this.extension = path.extname(params.value);
    params.value = path.basename(params.value, this.extension);

    super.agInit(params);
  }

  /**
   * Return the final value - called by the grid once after editing is complete
   */
  public getValue(): any {
    return this.control.value + this.extension;
  }
}
